import type { AssetTagRelationshipDTO } from '@/pages/Assets/Assets.types';

export const getComplianceFilterOptions = (
  assets: Array<{ compliance_tags?: AssetTagRelationshipDTO[] }>
) => {
  const complianceTags = assets.reduce<string[]>((uniqueTagNames, asset) => {
    if (asset.compliance_tags) {
      asset.compliance_tags.forEach((tag) => {
        if (!uniqueTagNames.includes(tag.tag_name)) {
          uniqueTagNames.push(tag.tag_name);
        }
      });
    }
    return uniqueTagNames;
  }, []);

  return complianceTags.map((tagName) => ({
    value: tagName,
    label: tagName,
    count: assets.filter((asset) =>
      asset.compliance_tags?.some((tag) => tag.tag_name === tagName)
    ).length
  }));
};

export default getComplianceFilterOptions;
